








































import { Component, Prop, Vue } from 'vue-property-decorator'
import api from '@api'
import { LoanRepaymentDetail, PartRepaymentData } from '@/api/model/repayment'

@Component
export default class extends Vue {
    detailList: PartRepaymentData[] = []
    recordList: LoanRepaymentDetail[] = []

    shouldLoading: boolean = false

    activated(): void {
        this.getData()
    }

    getData(): void {
        const { indexs, lid, rid } = this.$route.query
        this.shouldLoading = true
        api.repaymentService
            .queryRepaymentDetail({
                index: +indexs,
                lid: +lid,
                rid: +rid
            })
            .subscribe(res => {
                this.detailList = [res.partRepaymentResponse]
                this.recordList = res.list
                this.shouldLoading = false
            })
    }
}
